
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/used-cars/[make]/[model]/[slug]",
      function () {
        return require("private-next-pages/used-cars/[make]/[model]/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/used-cars/[make]/[model]/[slug]"])
      });
    }
  